import React, { Component } from "react";
import Select from "react-select";
import "../../Benefits/Benefits.css";
import { ToastContainer, toast } from "react-toastify";
import $ from "jquery";
import {
  main_url,
  getCookieData,
  validate,
  getActionStatus,
  alertText,
  havePermission,
  getWorkFlowStatus,
  stopSaving,
  startSaving,
  getBranch,
  getWithdrawalLocation,
  fno,
} from "../../../utils/CommonFunction";
import ApprovalForm from "../../Common/ApprovalForm";
import DocumentList from "../../Common/DocumentList";
import { getHeaders } from "../../../utils/apiHelper";

const SpouseCompanyOptions = [
  { value: 1, label: "Yes" },
  { value: 2, label: "No" },
];

var form_validate = true;
class BenefitWeddingAddNew extends Component {
  constructor(props) {
    super(props);
    var user_info = getCookieData("user_info");
    this.state = {
      visible: false,
      employee_name: user_info.fullname,
      designations: user_info.designations,
      user_branch: user_info.location_master_name,
      one_benefit: this.props.data,
      spouseDropDownList: [],
      employeeList: [],
      spouseName: "",
      spouse_id: null,
      employee_id: 0,
      spouseCompanyOption: 0,
      check_employee: "",
      check_spouse: "",
      check_spouse_name: "",
      status: 0,
      createdBy: 0,
      updatedBy: 0,
      user_id: user_info.user_id,
      selectedEmployee: [],
      selectedSpouseName: [],
      is_main_role: false,
      selectedSpouseCompany: "",
      status_title: "",
      doc: [],
      newDoc: [],
      attachment: [],
      work_flow_status: {},
      available_amount: 0,
      comment: "",
      selected_location: [], //Added by STHA
      branch: [], //Added by STHA
      withdraw_location: 0, //Added by STHA
    };
  }

  componentDidUpdate() {
    if (!form_validate) validate("check_form");
  }

  async componentDidMount() {
    fetch(`${main_url}main/getSpouseEmployee`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        const spouseDropDownList = list.map(employee => {
          return {
            value: employee.userId, 
            label: `${employee.employmentId} ${employee.name} ( ${employee.designation} - ${employee.branch} )`,
          };
        });
        this.setState({
          employeeList: list,
          spouseDropDownList: spouseDropDownList,
        });
        if (!Array.isArray(this.state.one_benefit)) {
          this.setOneBenefit();
        } else {
          this.getAvailabelAmount();
        }
      });

    this.getAllBranches(); //Added by STHA
  }

  getAvailabelAmount() {
    fetch(`${main_url}wedding_benefit/getWeddingAvailableAmount`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          available_amount: list.amount,
        });
      });
  }
  getDocument(id) {
    fetch(`${main_url}wedding_benefit/getDocument/${id}`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          doc: res,
        });
      })
      .catch((error) => console.log(error));
  }

  async setOneBenefit() {
    var one = this.state.one_benefit;
    var work_flow = await getWorkFlowStatus(
      one.user_id,
      this.state.user_id,
      "Wedding Benefit",
      "Benefit"
    );
    this.getDocument(one.benefit_id);
    // Must find selectedSpouseId from employeeList, not from spouseDropDownList
    // because spouseDropDownList doesn't have employmentId, here we need both userId and employmentId.
    const selectedSpouse = this.state.employeeList.find(employee => {
      return `${employee.userId}` === one.spouse_name || employee.employmentId === one.spouse_name;
    });
    this.setState({
      work_flow_status: work_flow,
      spouseName: one.spouse_name,
      spouse_id: one.spouse_id,
      employee_id: one.user_id,
      status: one.status,
      employee_name: one.employee_name,
      designations: one.designations,
      spouseCompanyOption: one.is_alliance_staff,
      available_amount: one.available_amount,
      selectedSpouseName: {
        value: !!selectedSpouse ? selectedSpouse.userId : one.spouse_name,
        label: !!selectedSpouse ? 
                `${selectedSpouse.employmentId} ${selectedSpouse.name} ( ${selectedSpouse.designation} - ${selectedSpouse.branch} )` 
                : one.staff_spouse_name,
      },
      selectedSpouseCompany: SpouseCompanyOptions[one.is_alliance_staff - 1],
      is_main_role: havePermission(work_flow),
    });
  }

  //Added by STHA
  getAllBranches = async () => {
    let one = this.state.one_benefit;

    const withdrawalLocations = await getWithdrawalLocation();
    let selected_location = this.getSelectedLocation(
      withdrawalLocations,
      one.withdraw_location
    );
    this.setState({
      branch: withdrawalLocations,
      selected_location: selected_location,
      withdraw_location: one.withdraw_location,
    });
  };

  //Added by STHA
  changeWithdrawLocation = (e) => {
    let data = this.state;
    data.withdraw_location = e.value;
    this.setState({
      selected_location: e,
      setupData: data,
    });
    console.log("Here is data ", this.state.withdraw_location);
  };

  //Added by STHA
  getSelectedLocation(branch, location) {
    let selected = branch.filter(function (b) {
      return b.value == location;
    });
    return selected;
  }

  handleSpouseName = (event) => {
    this.setState({
      spouseName: event.target.value,
    });
  };

  handleAllianceSpouseName = (event) => {
    this.setState({
      selectedSpouseName: event,
      spouseName: event.value,
    });
  };

  handleSpouseCompanyOptions = (event) => {
    let name = this.state.spouseName;
    if (event.value === 2) {
      name = "";
    }
    this.setState({
      spouseCompanyOption: event.value,
      selectedSpouseCompany: event,
      spouseName: name,
    });
  };

  handlefileChanged(event) {
    event.preventDefault();

    let newDoc = this.state.newDoc;
    var obj = document.querySelector("#attach_file").files.length;
    for (var i = 0; i < obj; i++) {
      var getfile = document.querySelector("#attach_file").files[i];
      newDoc.push(getfile);
    }

    this.setState({
      newDoc: newDoc,
    });
  }

  removeOldDocument(index, event) {
    var array = this.state.doc;
    array.splice(index, 1);
    this.setState({
      doc: array,
    });
  }

  //@kpk
  removeNewDocument(index, event) {
    var array = this.state.newDoc;
    array.splice(index, 1);
    this.setState({
      newDoc: array,
    });
  }

  checkFiles(e) {
    var files = document.getElementById("attach_file").files;
    var attachment = [];
    if (files.length > 2) {
      toast.warning("You can only upload a maximum of 2 files!");
    } else {
      for (let i = 0; i < files.length; i++) {
        attachment.push(files[i]);
      }
    }
    let newDoc = this.state.newDoc;
    var obj = document.querySelector("#attach_file").files.length;
    for (var i = 0; i < obj; i++) {
      var getfile = document.querySelector("#attach_file").files[i];
      newDoc.push(getfile);
    }
    document.getElementById("attach_file").value = "";
    this.setState({
      attachment: attachment,
      newDoc: newDoc,
    });
  }

  approvalStatus = (text, comment) => {
    this.setState({ status_title: text, comment: comment }, () => this.save());
  };

  save() {
    if (this.state.newDoc.length == 0 && this.state.doc.length == 0) {
      toast.error("Please Choose Attachment File!");
    } else {
      let { one_benefit, status_title, is_main_role, newDoc } = this.state;
      let editData =
        !Array.isArray(one_benefit) == true
          ? (this.state.newDoc.length > 0 ||
              this.state.attachment.length > 0 ||
              this.state.doc.length > 0) &&
            !Array.isArray(one_benefit)
          : !Array.isArray(one_benefit);
      if (
        validate("check_form") &&
        (this.state.attachment.length > 0 || editData)
      ) {
        $("#saving_button").attr("disabled", true);
        var data = {
          user_id: this.state.one_benefit.user_id
            ? this.state.one_benefit.user_id
            : this.state.user_id,
          is_alliance_staff: this.state.spouseCompanyOption,
          spouse_name: this.state.spouseName,
          available_amount: this.state.available_amount,
          status: this.state.status == 5 ? 0 : this.state.status,
          createdBy: this.state.one_benefit.user_id
            ? this.state.one_benefit.user_id
            : this.state.user_id,
          updatedBy: this.state.user_id,
          withdraw_location: this.state.withdraw_location, // Added by STHA
          form_no: this.state.one_benefit.form_no,
        };

        let status = 0;
        let path = "";

        if (!Array.isArray(one_benefit) && one_benefit !== null) {
          if (status_title !== "" && is_main_role) {
            var action = getActionStatus(
              status_title,
              one_benefit,
              this.state.user_id,
              this.state.comment
            );

            data.referback_by = action.referback_by;
            data.checked_by = action.checked_by;
            data.verified_by = action.verified_by;
            data.approved_by = action.approved_by;
            data.rejected_by = action.rejected_by;
            data.referback_date = action.referback_date;
            data.checked_date = action.checked_date;
            data.verified_date = action.verified_date;
            data.approved_date = action.approved_date;
            data.rejected_date = action.rejected_date;
            data.referback_comment = action.referback_comment;
            data.checked_comment = action.checked_comment;
            data.verified_comment = action.verified_comment;
            data.approved_comment = action.approved_comment;
            data.status = action.status;
            data.withdraw_location = this.state.withdraw_location; // Added by STHA
            if (status_title === "rejected") {
              data.rejected_comment = this.state.comment;
            }
          }
          path = `editWeddingBenefit/${one_benefit.benefit_id}`;
        } else {
          path = `saveWeddingBenefit`;
        }
        const formdata = new FormData();

        // var obj = document.querySelector("#attach_file").files.length;
        for (var i = 0; i < newDoc.length; i++) {
          // var imagedata = document.querySelector("#attach_file").files[i];
          var imagedata = newDoc[i]; // new doc HMH
          formdata.append("uploadfile", imagedata);
        }
        formdata.append("oldDoc", JSON.stringify(this.state.doc));
        formdata.append("wedding_benefit", JSON.stringify(data));

        fetch(`${main_url}wedding_benefit/${path}`, {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        })
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status !== 200) {
              this.setState({
                status: this.state.status,
              });
            }
            this.props.showToast(status, text);

            // console.log("Here is text -------------------", text);
            // if (status === 200) {
            //   this.props.showToast(status, text);
            //   window.location.reload("/wedding_benefit");
            // } else {
            //   let resp = JSON.parse(text); //Added by STHA
            //   this.props.showToast(status, resp);
            // }
          });
      } else {
        startSaving();
        toast.error(alertText, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  }

  render() {
    let { one_benefit } = this.state;

    return (
      <div className="container">
        <div className="row">
          <form id="check_form">
            {one_benefit.form_no && <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Voucher No.
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control input-md"
                    value={one_benefit.form_no ? fno.fno_wedding + one_benefit.form_no : ""}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="designation" className="col-sm-12">
                    Branch
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.user_branch}
                    disabled
                  />
                </div>
              </div>
            </div>}
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Employee Name
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control input-md"
                    value={this.state.employee_name}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="designation" className="col-sm-12">
                    Designation
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    // placeholder="Please Provide The Designation"
                    className="form-control"
                    value={this.state.designations}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Is Your Spouse An Alliance Staff ?
                  </label>
                </div>
                <div className="col-sm-10">
                  <Select
                    placeholder="Please Choose An Option"
                    options={SpouseCompanyOptions}
                    onChange={this.handleSpouseCompanyOptions.bind(this)}
                    value={this.state.selectedSpouseCompany}
                    className="react-select-container  checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="spouse-name" className="col-sm-12">
                    Spouse Name
                  </label>
                </div>
                <div className="col-sm-10">
                  {this.state.spouseCompanyOption === 1 ? (
                    <Select
                      options={this.state.spouseDropDownList}
                      placeholder="Please Choose Employee Name"
                      onChange={this.handleAllianceSpouseName.bind(this)}
                      className="react-select-container  checkValidate"
                      classNamePrefix="react-select"
                      value={this.state.selectedSpouseName}
                    />
                  ) : (
                    <input
                      type="text"
                      // placeholder="Please Provide The Employee Name"
                      className={`form-control checkValidate`}
                      onChange={this.handleSpouseName.bind(this)}
                      value={this.state.spouseName}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Available Amount
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control input-md"
                    value={this.state.available_amount}
                    disabled
                  />
                </div>
              </div>

              {/* Added by STHA */}
              <div className="col-md-6 form-group">
                <div>
                  <label className="col-sm-12">
                    Withdrawal Location
                    <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-sm-10">
                  <Select
                    data-name="withdraw_loction"
                    value={this.state.selected_location}
                    onChange={this.changeWithdrawLocation}
                    options={this.state.branch}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              {/* Added end by STHA */}
            </div>
            {!Array.isArray(this.state.one_benefit) ? (
              <div className="row">
                <div
                  className="form-group col-md-12"
                  style={{ overflowX: "auto" }}
                >
                  <div className="ownspacing"></div>
                  <h4>Wedding Benefit Document</h4>
                  <div className="col-md-12">
                    <input
                      type="file"
                      className="dropZone"
                      id="attach_file"
                      onChange={this.handlefileChanged.bind(this)}
                      multiple
                    />
                  </div>

                  <div className="ibox float-e-margins">
                    <div className="p-md col-md-12" style={{ float: "left" }}>
                      {this.state.doc.map((data, index) => (
                        <div className="fileuploader-items col-md-4">
                          <ul className="fileuploader-items-list">
                            <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                              <div className="columns">
                                <div className="column-title">
                                  <a
                                    href={`${main_url}wedding_benefit/getCRDocumentData/${data.name}`}
                                    download
                                    target="_blank"
                                    className="btn btn-primary document-body-bt document-width"
                                  >
                                    {data.name.split("&@")[1]}
                                  </a>
                                </div>
                                <div className="column-actions">
                                  <a
                                    className="fileuploader-action fileuploader-action-remove"
                                    onClick={(event) =>
                                      this.removeOldDocument(index, event)
                                    }
                                  >
                                    {" "}
                                    <i></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      ))}

                      {this.state.newDoc.map((data, index) => (
                        <div className="fileuploader-items col-md-4">
                          <ul className="fileuploader-items-list">
                            <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                              <div className="columns">
                                <div className="column-title">
                                  <a
                                    href="#"
                                    className="btn btn-primary document-body-bt document-width"
                                  >
                                    {data.name}
                                  </a>
                                </div>
                                <div className="column-actions">
                                  <a
                                    className="fileuploader-action fileuploader-action-remove"
                                    onClick={(event) =>
                                      this.removeNewDocument(index, event)
                                    }
                                  >
                                    {" "}
                                    <i></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // <div className="row">
              //     <div className="form-group col-md-6">
              //         <div>
              //             <label htmlFor="attachment" className="col-sm-12 custom-file-label">Provide At Least One Or At Most Two
              //         Attachment</label>
              //         </div>

              //         <div className="col-sm-10">
              //             <input className="dropZone" type="file" id="attach_file" multiple onChange={this.checkFiles.bind(this)}></input>

              //         </div>

              //     </div>
              // </div>
              <div className="form-group col-md-6">
                <div>
                  <label
                    htmlFor="attachment"
                    className="col-sm-12 custom-file-label"
                  >
                    Provide At Least One Or At Most Two Attachment
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    className="dropZone "
                    type="file"
                    id="attach_file"
                    multiple
                    onChange={this.checkFiles.bind(this)}
                  ></input>
                </div>
              </div>
            )}
          </form>
        </div>
        <div>
          {Array.isArray(this.state.one_benefit) &&
            this.state.newDoc.map((data, index) => (
              <div className="fileuploader-items col-md-4">
                <ul className="fileuploader-items-list">
                  <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                    <div className="columns">
                      <div className="column-thumbnail">
                        <div className="fileuploader-item-image fileuploader-no-thumbnail">
                          <div
                            className="fileuploader-item-icon"
                            style={{ backgroundColor: "#3f4fd3" }}
                          >
                            <i>{data.name.split(".")[1]}</i>
                          </div>
                        </div>
                        <span className="fileuploader-action-popup"></span>
                      </div>
                      <div className="column-title">
                        <span className="own-text">{data.name}</span>
                      </div>
                      <div className="column-actions">
                        <a
                          className="fileuploader-action fileuploader-action-remove"
                          onClick={(event) =>
                            this.removeNewDocument(index, event)
                          }
                        >
                          {" "}
                          <i></i>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            ))}
        </div>

        <div className="row save-btn">
          {!Array.isArray(one_benefit) &&
          havePermission(this.state.work_flow_status) &&
          this.state.one_benefit.user_id != this.state.user_id ? (
            <ApprovalForm
              approvalStatus={this.approvalStatus.bind(this)}
              status={this.state.status}
              work_flow={this.state.work_flow_status}
              total_amount={this.state.available_amount}
            />
          ) : (
            <div className="float-right">
              <div>
                {this.state.one_benefit.status == undefined ||
                this.state.one_benefit.status == 5 ? (
                  <div>
                    <button
                      onClick={this.save.bind(this)}
                      className="btn btn-primary"
                      id="saving_button"
                      type="button"
                    >
                      Save
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {/* <button className="btn btn-primary" id="saving_button" type="button" onClick={this.save.bind(this)}>Save</button> */}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default BenefitWeddingAddNew;
